export const UTMPlaceholders = ['NETWORK', 'ACCOUNT', 'CATEGORY'];
